import { Paper, Stack, Text } from '@mantine/core';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { TitleCard } from '@/core/components';

import { TechnologicalTransfer } from '../../model/TechnologicalTransferTypes';
import classes from './TechnologicalTransferCard.module.css';

export interface TechnologicalTransferCardProps {
  technologicalTransfer: TechnologicalTransfer;
  to?: string;
  onClick?: () => void;
}

export function TechnologicalTransferCard({ technologicalTransfer, to, onClick }: TechnologicalTransferCardProps) {
  const { title, registrationNo, type, typeName, partnerType, partnerTypeName, domain, domainName } =
    technologicalTransfer;
  const { t } = useTranslation();

  return (
    <Paper
      className={classes.card}
      onClick={onClick}
      component={to != null ? Link : undefined}
      to={to}
      p="lg"
      c="var(--mantine-color-text)"
    >
      <Stack gap="10px">
        <TitleCard title={title} />
        <Text
          c="dimmed"
          size="sm"
        >
          {type === 'OTHER' ? typeName : t(`technologicalTransfers.typeEnum.${type}`)}, {registrationNo}
        </Text>
        <Text
          c="dimmed"
          size="sm"
        >
          {partnerType === 'OTHER' ? partnerTypeName : t(`technologicalTransfers.partnerTypeEnum.${partnerType}`)}
        </Text>
        <Text
          c="dimmed"
          size="sm"
        >
          {domain === 'OTHER' ? domainName : t(`technologicalTransfers.domainEnum.${domain}`)}
        </Text>
      </Stack>
    </Paper>
  );
}
